import { Component, OnInit } from '@angular/core';
import { AuthService } from '../authentication/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { on } from 'cluster';
import * as moment from 'moment';


@Component({
  selector: 'app-login-boxed',
  templateUrl: './login.component.html',
  styles: []
})
export class LoginBoxedComponent implements OnInit {

  msg: any;

  loginData: any = {
    grant_type: 'password',
    username: '',
    password: '',
    scope: '3'
  };
  validateEmail: boolean = true;
  date: string;

  constructor(private authService: AuthService,
    private router: Router,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.date = moment(new Date()).format('YYYY');
  }


  emailValidation (username) {
    let regex =/^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[A-Za-z0-9]+(\-[A-Za-z0-9]+)*(\.[A-Za-z0-9]+(\-[A-Za-z0-9]+)*)*\.[A-Za-z]{2,4}$/;
 if (regex.test(username)) {
    this.validateEmail = false;
 }
 else
 {
     this.validateEmail = true;
 }
 }
  onSubmit(data) {
    const loginDetails = JSON.parse(JSON.stringify(data))
    loginDetails.username = loginDetails.username.toLowerCase()
    this.authService.login(loginDetails)
      .pipe(first())
      // tslint:disable-next-line:no-shadowed-variable
      .subscribe((data) => {
        console.log('in login', data);
        if (this.authService.isLoggedIn) {
          this.toastr.success('Login Successfully!');
          const redirect = this.authService.redirectUrl ? this.authService.redirectUrl : '/apps/dashboards/analytics';
          console.log('ppppppppppp', redirect);
          this.router.navigate([redirect]);
        } else {
        }
      }, error => {
        console.log('fail callback', error.status);
        if (error.status === 403) {
          this.toastr.info('Please verify your email!');
        }if (error.status === 400) {
          this.toastr.error('invalid credentials!');
        }
        if (error.status === 500) {
          this.msg = 'Enter valid email';
        }
      });
  }

  /**
   * Custom Function, To Submit Form on Hitting Enter
   * @param event 
   */
  keyDownFunction(event) {
    if (event.keyCode === 13) {
    this.onSubmit(this.loginData);
    }
  }

}
